<template>
  <div :class="{ slim }" class="sf-progress">
    <div :style="{ width: progress }" :class="[backgroundClass]" class="progress"/>
    <div :style="{ left: progress }" :class="{ finish }" class="percent sf-secondary">
      {{ progress }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, required: true },
    total: { type: Number, required: true },
    slim: { type: Boolean, default: false },
    percent: { type: String, default: '' },
    backgroundClass: { type: String, default: 'sf-bg-ternary' },
  },
  computed: {
    progress() {
      return this.percent !== ''
        ? this.percent + '%'
        : `${((this.value / this.total) * 100).toFixed()}%`;
    },
    finish() {
      return Number(this.value) === this.total;
    },
  },
};
</script>
